import { render, staticRenderFns } from "./dictAddOrUpdate.vue?vue&type=template&id=e79468c4&scoped=true&"
import script from "./dictAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./dictAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79468c4",
  null
  
)

export default component.exports